import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    userInfo:{},
    cjt:false,
    orgid:'',
    userUnRead: 0,
    isVip: 0,
    //dayi详情id
    dayiDetailID:{
      id:''
    },
    //sbw详情
    sbwDetails:{

    }
  },
  mutations: {
    //用户信息存储
    userDetail(state, info) {
      console.log('set userInfo')

      state.userInfo = info
    },
    //是否是畅捷通
    CJT(state, info) {
      state.cjt = info
    },
    //畅捷通url返回的orgId
    orgId(state, info) {
      state.orgid = info
    },
    //未读信息
    userUnRead(state, info) {
      state.userUnRead = info
    },
    //vip信息
    isVip(state, info) {
      console.log('set isVip' , info)
      state.isVip = info
    },
    //添加答疑详情id
    getDayiDetailID(state, info){
      state.dayiDetailID = info
    },
    //添加随便问 详情
    getSBWDetailInfo(state, info){
      state.sbwDetails = info
    }
  },
  actions: {

  },
  modules: {
  }
})
